import { render, staticRenderFns } from "./AuthorContent.vue?vue&type=template&id=e6d83ef2&scoped=true&"
import script from "./AuthorContent.vue?vue&type=script&lang=js&"
export * from "./AuthorContent.vue?vue&type=script&lang=js&"
import style0 from "./AuthorContent.vue?vue&type=style&index=0&id=e6d83ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d83ef2",
  null
  
)

export default component.exports